import CodeMirror from 'codemirror';
import { isAcceptableDate, isAcceptableTime, isAcceptableDateTime } from '../../ast/utils';


export function isOpenParenthesisToken(token: CodeMirror.Token) {
  return token && token.type === 'bracket' && token.string === '(';
}

export function isCloseParenthesisToken(token: CodeMirror.Token) {
  return token && token.type === 'bracket' && token.string === ')';
}

export function isDateToken(token: CodeMirror.Token) {
  if (!token || token.type !== 'string') {
    return false;
  }
  const value = token.string.substr(1, token.string.length - 2);
  return isAcceptableDate(value);
}

export function isTimeToken(token: CodeMirror.Token) {
  if (!token || token.type !== 'string') {
    return false;
  }
  const value = getStringTokenValue(token.string);
  return isAcceptableTime(value);
}

export function isDateTimeToken(token: CodeMirror.Token) {
  if (!token || token.type !== 'string') {
    return false;
  }
  const value = token.string.substr(1, token.string.length - 2);
  return isAcceptableDateTime(value);
}


// 判断是否为ID类型的Token
export function isIDToken(token: CodeMirror.Token) {
  if (!token) { return false; }

  if (token.type === 'string') {
    return /^[a-zA-Z0-9\-_]+$/.test(getStringTokenValue(token.string));
  }
  if (token.type === 'number') {
    return /^\d+$/.test(token.string);
  }

  return false;
}

export function getStringTokenValue(v: string) {
  return v.substr(1, v.length - 2);
}

// 获取当前Token前的第一个有效Token
export function getPrevEffectiveToken(editor: CodeMirror.Editor, token: CodeMirror.Token) {
  try {

    let prevToken = editor.getTokenAt({ line: token.state.line, ch: token.start });

    while (prevToken.end > 0) {
      if (prevToken.type !== null) {
        return prevToken;
      }

      // Fix: 解决表达式第一行第一个字符串为空格时 `editor.getTokenAt` 报错的问题
      try {
        prevToken = editor.getTokenAt({ line: prevToken.state.line, ch: prevToken.start });
      } catch (err) {
        return null;
      }
    }
    return null;
  } catch (err) {
    return null;
  }
}


// 判断Token是否为函数，并匹配函数名称
export function isFunctionToken(token: CodeMirror.Token, name?: string) {
  const isFunction = token.type === 'function';

  if (name) {
    return isFunction && name.toUpperCase() === token.string.toUpperCase();
  }

  return isFunction;
}


export function hasTokenIncludes(token: CodeMirror.Token | null, types: string[]) {
  if (!token || !token.type) return false;

  const tokenTypes = token.type.split(' ');
  for (const type of types) {
    if (!tokenTypes.includes(type)) {
      return false;
    }
  }
  return true;
}

// 根据左括号获取右括号位置
export function getCloseBracketPosition(
  tokens: CodeMirror.Token[],
  start: number,
  openBracket: '(' | '{' | '[',
  closeBracket: ')' | '}' | ']'
) {
  let i = start;
  let bracketCount = 0;
  while ((i < tokens.length && bracketCount > 0) || i === start) {
    const itoken = tokens[i++];
    if (itoken.type === 'bracket' && itoken.string === openBracket) {
      bracketCount++;
    } else if (itoken.type === 'bracket' && itoken.string === closeBracket) {
      bracketCount--;
    }
  }

  if (bracketCount > 0) {
    return -1;
  }

  return i - 1;
}


// 将Tokens以逗号分割为一个数组
export function splitTokensWithComma(tokens: CodeMirror.Token[]) {
  const tokensArr: CodeMirror.Token[][] = [];
  tokens.forEach(token => {
    if (tokensArr.length === 0 || token.type === 'comma') {
      tokensArr.push([]);
    }
    if (token.type && token.type !== 'comma') {
      tokensArr[tokensArr.length - 1].push(token);
    }
  });
  return tokensArr;
}
